import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { loginAs } from '../../../stores/auth/actionCreators';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selectedOne, singleSelected } from '../../../stores/tables/selectors';
import { isOldUser } from '../../../stores/users/selectors';
import { fetchTableUsers } from '../../../stores/users/actionCreators';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    selectedOne: boolean;
    singleSelected: string | undefined;
    isOldUser: (id: string) => boolean;
    loginAs: (id?: string, refreshTable?: boolean) => void;
}

class LoginAsAction extends React.Component<Props> {
    public constructor(props: Props) {
        super(props);
    }

    public render() {
        const t = this.props.translate;
        const id = (this.props.singleSelected)? this.props.singleSelected :""; 
        if (this.props.selectedOne &&
            this.props.hasPrivilege(['LOGIN_AS', 'SUPER_ADMIN']) && !this.props.isOldUser(id)) {
            return (
                <React.Fragment>
                    <DropdownItem
                        onClick={() => {
                            this.props.loginAs(this.props.singleSelected, true);
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'sign-in']} />
                        {t('users.button.loginAs')}
                    </DropdownItem>

                </React.Fragment>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    selectedOne: selectedOne(state, 'users'),
    singleSelected: singleSelected(state, 'users'), 
    isOldUser: isOldUser(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    loginAs: (id?: string, refreshTable?: boolean) => id ? dispatch(loginAs(id, refreshTable)) : null,
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(LoginAsAction));